import * as Yup from 'yup'
import { messageHelper } from 'utils/messageHelper'

export const recipientSchema = Yup.object().shape({
  email: Yup.string()
    .email(messageHelper.yup.error.emailIsInvalid)
    .required(messageHelper.yup.error.emailIsMandatory),
  fullName: Yup.string().required(messageHelper.yup.error.nameIsMandatory),
  documentNumber: Yup.string().required(
    messageHelper.yup.error.documentIsMandatory
  )
})

export const passwordSchema = Yup.object().shape({
  password: Yup.string().required('Senha é obrigatória'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais')
    .required('Confirmação de senha é obrigatória')
})
